import React from 'react';

import Header from '../Blocks/Header';
import Cluster from '../Support/Cluster';

const profile = (props) => (
	<Cluster>
		<Header />
		<div className='page'>

		</div>
	</Cluster>
);

export default profile;


// WEBPACK FOOTER //
// ./src/Pages/Profile.js